module.exports = __webpack_public_path__ + "img/img5.ed921e6c.png";